import { useEffect, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const pathsToBlock = ['eg/edit-advanced'];

export function useSwipeBlocker() {
  const location = useLocation();

  const shouldBlock = useMemo(
    () => pathsToBlock.some(path => location.pathname.includes(path)),
    [location.pathname]
  );

  // To prevent pushing history multiple times during same block period
  const pushedRef = useRef(false);

  useEffect(() => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    const onPopState = (e) => {
      if (e.state?.isTrap) {
        window.history.forward();
      }
    };

    if (shouldBlock) {
      // Prevent overscroll for Chrome, Edge, etc.
      document.documentElement.style.overscrollBehaviorX = 'none';
      document.body.style.overscrollBehaviorX = 'none';

      if (isSafari && !pushedRef.current) {
        // Push only once when blocking starts
        window.history.pushState({ isTrap: true }, '');
        window.history.pushState({ isTrap: true }, '');
        pushedRef.current = true;

        window.addEventListener('popstate', onPopState);
      }
    } else {
      // Clean overscroll styles
      document.documentElement.style.overscrollBehaviorX = '';
      document.body.style.overscrollBehaviorX = '';

      // Remove listener only if it was added
      if (isSafari && pushedRef.current) {
        window.removeEventListener('popstate', onPopState);
        pushedRef.current = false;
      }
    }

    // Cleanup on unmount or when shouldBlock changes
    return () => {
      document.documentElement.style.overscrollBehaviorX = '';
      document.body.style.overscrollBehaviorX = '';
      if (isSafari && pushedRef.current) {
        window.removeEventListener('popstate', onPopState);
        pushedRef.current = false;
      }
    };
  }, [shouldBlock]);
}